package ru.villawonka.app.domain.usecase

import ru.villawonka.app.domain.repository.UserRepository

class IsNewUserUseCase(
    private val userRepository: UserRepository
) {

    operator fun invoke() = userRepository.isNewUser()
}